<template>
  <div ref="anyPlace" class="p-8">
    <h2 class="font-semibold uppercase text-gray-600">Add Scheduled Ride</h2>
    <form @submit.prevent="add">
      <div class="flex -mx-4">
        <div class="w-1/3">
          <div class="p-4">
            <label class="block">
              <span class="text-gray-700">Rider Contact Number</span>
              <div class="flex row">
                <h3 class="pt-3 pr-3">+251</h3>
                <div class="w-full">
                  <input
                    required
                    minlength="9"
                    maxlength="9"
                    v-model="phoneNumber"
                    class="form-input mt-1 block w-full"
                    placeholder="912 345678"
                    @keyup="searchRiders(phoneNumber)"
                  />
                  <ul
                    v-if="riders.length"
                    class="absolute max-h-56 mt-1 bg-white border rounded shadow overflow-y-auto"
                  >
                    <li
                      v-for="(result, index) in riders"
                      :key="`pickadd-${index}`"
                      class="px-3 py-2 cursor-pointer hover:bg-blue-500 hover:text-white"
                      v-bind:class="{
                        'bg-red-100 hover:bg-blue-700 hover:text-red-500 cursor-not-allowed':
                          result.disabled
                      }"
                      @click="selectRider(result)"
                    >
                      {{ result.firstName + " " + result.lastName }},
                      {{ result.phoneNumber }}
                    </li>
                  </ul>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="w-1/3">
          <div class="p-4">
            <label class="block">
              <span class="text-gray-700">Rider Name</span>
              <input
                v-model="riderName"
                class="form-input mt-1 block w-full"
                placeholder="Melaku Wedajo"
              />
            </label>
          </div>
        </div>
        <div class="w-1/3">
          <div class="p-4">
            <label class="block">
              <span class="text-gray-700">Rider Email</span>
              <input
                class="form-input mt-1 block w-full"
                v-model="email"
                placeholder="melaku.wedajo@domain.com"
              />
            </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="flex -mx-4">
        <div class="w-1/3 bg-blue" style="min-height:70vh">
          <div class="p-4">
            <div class="p-4 border rounded-lg space-y-4">
              <div>
                <label class="block">
                  <span class="text-gray-700">Vehicle Type</span>
                  <select
                    @change="setVehicleType"
                    class="form-select mt-1 block w-full"
                  >
                    <option value>Select a vehicle type...</option>
                    <option
                      v-for="type in vehicleTypes"
                      :key="type._id"
                      :value="type._id"
                      :selected="vehicleType === type._id"
                      >{{ type.name }}</option
                    >
                  </select>
                </label>
              </div>

              <div class="flex">
                <div class="w-1/2 mr-2">
                  <label class="block">
                    <span class="text-gray-700">Type</span>
                    <select
                      v-model="type"
                      class="form-select mt-1 block w-full"
                    >
                      <option value="normal">Normal</option>
                      <option value="bid">Bid</option>
                      <option value="rent">Rent</option>
                      <option value="corporate">Corporate</option>
                    </select>
                  </label>
                </div>

                <div v-if="type == 'corporate'" class="w-1/2">
                  <label class="block">
                    <span class="text-gray-700"
                      >Ticket
                      <small
                        v-if="ticketId"
                        class="text-green-800 bg-green-200 border border-green-800 px-2 py-px rounded"
                        >Verified
                      </small>
                      <small
                        v-if="ticketError"
                        class="text-red-800 bg-red-200 border border-red-800 px-2 py-px rounded"
                        >Invalid
                      </small>
                    </span>
                    <input
                      :disabled="ticketLoading"
                      class="form-input mt-1 block w-full"
                      type="text"
                      v-model="ticket"
                      maxlength="10"
                      minlength="10"
                      required
                      placeholder="Ticket"
                    />
                  </label>
                </div>

                <div v-if="type == 'bid'" class="w-1/2">
                  <label class="block">
                    <span class="text-gray-700">Amount</span>
                    <input
                      class="form-input mt-1 block w-full"
                      type="text"
                      v-model="bidAmount"
                      required
                      placeholder="Amount"
                    />
                  </label>
                </div>

                <div class="w-1/2" v-if="type == 'normal'">
                  <label class="block">
                    <span class="text-gray-700">Schedule</span>
                    <select
                      v-model="scheduled"
                      class="form-select mt-1 block w-full"
                    >
                      <option :value="false">Now</option>
                      <option :value="true">Scheduled</option>
                    </select>
                  </label>
                </div>
              </div>

              <div v-if="scheduled && type == 'normal'" class="flex">
                <div class="w-1/2 pr-2">
                  <label class="block">
                    <p class="text-gray-700 mb-1">Pickup Date</p>
                    <v-date-picker
                      :value="date"
                      v-model="date"
                      :popover="{ visibility: 'click' }"
                    />
                  </label>
                </div>
                <div class="w-1/2 flex">
                  <div class="w-1/2 mr-1">
                    <label class="block">
                      <span class="text-gray-700">Hour</span>
                      <select
                        v-model="hour"
                        class="form-select mt-1 block w-full"
                      >
                        <option v-for="i in 24" :key="i" :value="i">{{
                          i
                        }}</option>
                      </select>
                    </label>
                  </div>
                  <div class="w-1/2">
                    <label class="block">
                      <span class="text-gray-700">Minute</span>
                      <select
                        v-model="minute"
                        class="form-select mt-1 block w-full"
                      >
                        <option v-for="i in 12" :key="i" :value="(i - 1) * 5">{{
                          ((i - 1) * 5).toString().padStart(2, "0")
                        }}</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>

              <div v-if="type == 'rent'" class="flex">
                <div class="w-full flex">
                  <div class="w-1/3 mr-1">
                    <label class="block">
                      <span class="text-gray-700">Hour</span>
                      <select
                        v-model="rentHour"
                        class="form-select mt-1 block w-full"
                      >
                        <option v-for="i in 24" :key="i" :value="i">{{
                          i
                        }}</option>
                      </select>
                    </label>
                  </div>
                  <div class="w-1/3 mr-1">
                    <label class="block">
                      <span class="text-gray-700">Day</span>
                      <select
                        v-model="rentDay"
                        class="form-select mt-1 block w-full"
                      >
                        <option v-for="i in 31" :key="i" :value="i">{{
                          i
                        }}</option>
                      </select>
                    </label>
                  </div>
                  <div class="w-1/3">
                    <label class="block">
                      <span class="text-gray-700">Month</span>
                      <select
                        v-model="rentMonth"
                        class="form-select mt-1 block w-full"
                      >
                        <option v-for="i in 12" :key="i" :value="i">{{
                          i
                        }}</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>

              <div class="-mx-4">
                <div class="px-4">
                  <OriginAddressSearchBox
                    v-model="pickupAddress"
                    v-on:input="estimate"
                  />
                </div>
                <div class="px-4">
                  <DestinationAddressSearchBox
                    v-model="destinationAddress"
                    v-on:input="estimate"
                  />
                </div>
              </div>

              <div class="w-full" v-if="role == 1">
                <label class="block">
                  <span class="text-gray-700">Assign Driver</span>
                  <input
                    class="form-input mt-1 block w-full"
                    type="text"
                    v-model="driverName"
                    placeholder="Search for drivers..."
                    v-on:keyup="searchDriver(driverName)"
                  />
                  <ul
                    v-if="drivers.length"
                    class="absolute max-h-56 mt-1 bg-white border rounded shadow overflow-y-auto"
                  >
                    <li
                      v-for="(result, index) in drivers"
                      :key="`pickadd-${index}`"
                      class="px-3 py-2 cursor-pointer hover:bg-blue-500 hover:text-white"
                      v-bind:class="{
                        'bg-red-100 hover:bg-blue-700 hover:text-red-500 cursor-not-allowed':
                          result.disabled
                      }"
                      @click="selectDriver(result)"
                    >
                      {{ result.firstName + " " + result.lastName }},
                      {{ result.phoneNumber }}
                    </li>
                  </ul>
                </label>
              </div>
              <div>
                <label class="block">
                  <button
                    :disabled="dispatching"
                    class="flex items-center w-full justify-center py-2 text-white font-semibold rounded"
                    :class="
                      dispatching
                        ? 'bg-blue-300 cursor-not-allowed'
                        : 'bg-blue-500 hover:bg-blue-700'
                    "
                  >
                    <span
                      v-if="dispatching"
                      class="flex items-center space-x-2"
                    >
                      <i class="material-icons spin">sync</i>
                      <span>Dispatching</span>
                    </span>
                    <span v-else>Dispach</span>
                  </button>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/3">
          <div class="p-4">
            <div>
              <h3 class="font-semibold mb-4">Ride Esitmate</h3>
              <div
                class="flex justify-between items-center border-t border-b py-2"
              >
                <span>Base Fare</span>
                <span>ETB {{ baseFare }}</span>
              </div>
              <div class="flex justify-between items-center border-b py-2">
                <span>Distance</span>
                <span>{{ distance.toFixed(2) }} KM</span>
              </div>
              <div class="flex justify-between items-center border-b py-2">
                <span>ETA</span>
                <span>{{ durationString }} Hrs</span>
              </div>
              <div class="flex justify-between items-center border-b py-2">
                <span>Estimated Fare Total</span>
                <span>ETB {{ estimatedFare }}</span>
              </div>
            </div>
          </div>
          <div class="h-64" style="min-height:45vh">
            <div
              class="bg-teal-600 w-full h-full rounded-lg shadow overflow-hidden"
              ref="map"
            ></div>
          </div>
        </div>
        <div class="w-1/3 bg-white overflow-y-scroll">
          <!-- <div class="border p-3 m-2">
            <small>
              <strong>elnatal debebe</strong>
              <strong>+251911148312</strong>
            </small>
            <br />
            <small>
              <strong>From</strong> - Shiromeda Bus Station, Haile Melekot Street, Addis Ababa, Ethiopia Bole International Airport, Addis Ababa, Ethiopia
            </small>
            <br />
            <small>
              <strong>To</strong> - Bole International Airport, Addis Ababa, Ethiopia
            </small>
            <br />
            <small>
              <strong>Status</strong> - Requested
            </small>
          </div> -->

          <div
            v-for="(request, index) in requests"
            :key="index"
            class="border p-3 m-2"
          >
            <small>
              <strong>{{
                request.passenger
                  ? request.passenger.firstName +
                    " " +
                    request.passenger.lastName
                  : "-"
              }}</strong>
              ,
              <strong>{{
                request.passenger ? request.passenger.phoneNumber : "-"
              }}</strong>
            </small>
            <br />
            <small>
              <strong>From</strong> - {{ request.pickUpAddress.name }}
            </small>
            <br />
            <small>
              <strong>To</strong> -
              {{ request.dropOffAddress ? request.dropOffAddress.name : "" }}
            </small>
            <br />
            <small>
              <strong>Type</strong> - {{ request.vehicleType.name }}
            </small>
            <br />
            <small> <strong>Status</strong> - {{ request.status }} </small>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { focus } from "vue-focus";
import OriginAddressSearchBox from "@/components/OriginAddressSearchBox";
import DestinationAddressSearchBox from "@/components/DestinationAddressSearchBox";
import io from "socket.io-client";
import { config } from "@/config";
import init from "@/gmaps";

export default {
  directives: {
    focus
  },
  components: {
    OriginAddressSearchBox,
    DestinationAddressSearchBox
  },
  data() {
    return {
      driverName: "",
      requests: [],
      drivers: [],
      selectedDriver: null,
      estimateFare: 0,
      duration: 0,
      distance: 0,
      riders: [],
      ticketError: false,
      scheduled: false,
      type: "normal",
      riderId: "",
      fare: 0,
      dispatching: false,
      email: "",
      socket: null,
      phoneNumber: "",
      riderName: "",
      pickupAddress: {
        name: "",
        place_id: ""
      },
      destinationAddress: {
        name: "",
        place_id: ""
      },
      vehicleType: "",
      date: new Date(),
      hour: 1,
      minute: 0,
      rentHour: 1,
      rentDay: 1,
      rentMonth: 1,
      route: [],
      ticket: "",
      ticketId: "",
      ticketLoading: false,
      bidAmount: 0,
      focused: {
        "0": true,
        "1": false,
        "2": false
      },
      mapsService: null,
      google: null,
      vehicleTypes: [],
      markers: [],
      map: null,
      fromMarker: null,
      toMarker: null,
      path: null
    };
  },
  created() {
    this.socket = io(`${config.baseURL}/dispatcher-socket`);

    // Register the event listeners
    this.socket.on("request", request => {
      console.log(request);
    });

    this.socket.on("noAvailableDriver", () => {
      console.log("No drivers are avialable!");
      window.flash({ type: "error", body: "No drivers are avialable!" });
      this.dispatching = false;
    });

    this.socket.on("requestCanceled", () => {
      console.log("The request has been cancelled!");
      this.dispatching = false;
    });

    this.socket.on("requests", requests => {
      console.log({ requests });
      this.requests = requests;
    });

    this.socket.on("trip", data => {
      console.log("The request has been accepted!");
      window.flash({ type: "success", body: "Trip is accepted!" });

      console.log(data);
    });

    this.socket.on("searching", () => {
      window.flash({ type: "success", body: "The trip has been dispatched!" });
      this.dispatching = false;
      this.phoneNumber = "";
      this.riderName = "";
      this.email = "";
      this.riderId = "";
      this.destinationAddress = {
        name: "",
        place_id: ""
      };
      this.pickupAddress = {
        name: "",
        place_id: ""
      };
      this.drivers = [];
      this.driverName = "";
      this.selectedDriver = null;
      this.fare = 0;
      this.duration = 0;
      this.ticket = "";
      this.ticketId = "";
      this.ticketLoading = false;
      this.ticketError = false;
      this.distance = 0;
      this.date = new Date();
    });

    this.socket.on("estimate-response", data => {
      // expected response
      // base fare - from vehicle type
      // distance - from the response
      // eta - from the response
      // fare total - calculation
      // tax - ???
      // total - calculation
      this.duration = data.duration;
      this.distance = data.distance;
      this.fare = data.fare;
      this.route = data.route;
      this.estimateFare = data;

      if (this.route) {
        if (this.fromMarker) {
          this.fromMarker.setMap(null);
        }

        if (this.toMarker) {
          this.toMarker.setMap(null);
        }

        if (this.path) {
          this.path.setMap(null);
        }

        this.fromMarker = new this.google.maps.Marker({
          position: {
            lat: this.route[0][1],
            lng: this.route[0][0]
          },
          icon: {
            path:
              "m 12,2.4000002 c -2.7802903,0 -5.9650002,1.5099999 -5.9650002,5.8299998 0,1.74375 1.1549213,3.264465 2.3551945,4.025812 1.2002732,0.761348 2.4458987,0.763328 2.6273057,2.474813 L 12,24 12.9825,14.68 c 0.179732,-1.704939 1.425357,-1.665423 2.626049,-2.424188 C 16.809241,11.497047 17.965,9.94 17.965,8.23 17.965,3.9100001 14.78029,2.4000002 12,2.4000002 Z",
            fillColor: "#00FF00",
            fillOpacity: 1.0,
            strokeColor: "#000000",
            strokeWeight: 2,
            scale: 2,
            anchor: new this.google.maps.Point(12, 24)
          }
        });

        this.fromMarker.setMap(this.map);

        this.toMarker = new this.google.maps.Marker({
          position: {
            lat: this.route[this.route.length - 1][1],
            lng: this.route[this.route.length - 1][0]
          },
          icon: {
            path:
              "m 12,2.4000002 c -2.7802903,0 -5.9650002,1.5099999 -5.9650002,5.8299998 0,1.74375 1.1549213,3.264465 2.3551945,4.025812 1.2002732,0.761348 2.4458987,0.763328 2.6273057,2.474813 L 12,24 12.9825,14.68 c 0.179732,-1.704939 1.425357,-1.665423 2.626049,-2.424188 C 16.809241,11.497047 17.965,9.94 17.965,8.23 17.965,3.9100001 14.78029,2.4000002 12,2.4000002 Z",
            fillColor: "#ff0000",
            fillOpacity: 1.0,
            strokeColor: "#000000",
            strokeWeight: 2,
            scale: 2,
            anchor: new this.google.maps.Point(12, 24)
          }
        });

        this.toMarker.setMap(this.map);

        var route = this.route.map(coord => {
          return { lat: coord[1], lng: coord[0] };
        });

        this.path = new this.google.maps.Polyline({
          path: route,
          geodesic: true,
          strokeColor: "#FF0000",
          strokeOpacity: 1.0,
          strokeWeight: 2
        });

        this.path.setMap(this.map);
      }
    });

    this.socket.emit("init", { id: this.id });

    this.getVehicleTypes();
  },
  async mounted() {
    this.google = await init();

    this.map = new this.google.maps.Map(this.$refs.map, {
      center: {
        lat: 9.004912,
        lng: 38.778282
      },
      zoom: 10
    });
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    baseFare() {
      const selected = this.vehicleTypes.find(v => v._id === this.vehicleType);
      return selected && selected != undefined && this.type != "bid"
        ? selected.baseFare
        : 0;
    },
    estimatedFare() {
      const selected = this.vehicleTypes.find(v => v._id === this.vehicleType);
      return selected && selected != undefined
        ? this.type == "bid"
          ? this.bidAmount
          : (
              this.distance * selected.pricePerKM +
              this.duration * selected.pricePerMin +
              selected.baseFare
            ).toFixed(2)
        : 0;
    },
    durationString() {
      var minute = this.duration % 60;
      var hour = (this.duration - minute) / 60;
      return (
        hour +
        ":" +
        Math.round(minute)
          .toString()
          .padStart(2, "0")
      );
    },
    id() {
      return this.$store.state.auth.account._id;
    }
  },
  watch: {
    ticket() {
      this.validateTicket();
    },
    phoneNumber() {
      this.validateTicket()
    }
  },
  methods: {
    setVehicleType(e) {
      console.log("select");
      if (e.target.value.trim() == "") {
        console.log("herr");
        this.vehicleType = "";
        this.duration = 0;
        this.distance = 0;
        this.fare = 0;
        return;
      }

      this.duration = 0;
      this.distance = 0;
      this.fare = 0;
      this.vehicleType = e.target.value;
      this.estimate();
    },
    getVehicleTypes() {
      this.loading = true;
      this.$http
        .get("vehicleTypes")
        .then(response => {
          this.vehicleTypes = response.data.data;
          console.log(this.vehicleTypes);
          var vt = this.vehicleTypes.find(type => type.name === "Any");
          if (vt) {
            this.vehicleType = vt._id;
          } else if (this.vehicleTypes.length) {
            this.vehicleType = this.vehicleTypes[0]._id;
          }
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    changeFocus(current, next) {
      this.focused[current] = false;
      this.focused[next] = true;
    },
    add() {
      var intPhone = parseInt(this.phoneNumber);
      if (
        intPhone &&
        intPhone.toString().length == 9 &&
        this.pickupAddress &&
        this.pickupAddress.place_id &&
        this.destinationAddress &&
        this.destinationAddress.place_id &&
        this.vehicleType
      ) {
        var data = {
          pickUpAddress: this.pickupAddress,
          dropOffAddress: this.destinationAddress,
          vehicleType: this.vehicleType,
          name: this.riderName,
          type: this.type,
          passengerId: this.riderId,
          email: this.email,
          phone: "+251" + intPhone.toString()
        };

        if (this.scheduled && this.type == "normal") {
          var dateTime = new Date(this.date);
          dateTime.setHours(this.hour);
          dateTime.setMinutes(this.minute);
          data["schedule"] = dateTime;
        }
        if (this.selectedDriver && this.selectedDriver.vehicle) {
          data.vehicle = this.selectedDriver.vehicle._id;
          data.driver = this.selectedDriver._id;
        }

        if (this.type == "corporate" && this.ticketId) {
          data["ticket"] = this.ticketId;
        } else if (this.type == "corporate" && !this.ticketId) {
          this.ticketError = true;
          return;
        }

        if (this.type == "bid") {
          data["bidAmount"] = this.bidAmount;
        }

        if (this.type == "rent") {
          var startTimestamp = new Date();
          var endTimestamp = new Date();
          endTimestamp.setHours(endTimestamp.getHours() + this.rentHour);
          endTimestamp.setDate(endTimestamp.getDate() + this.rentDay);
          endTimestamp.setMonth(endTimestamp.getMonth() + this.rentMonth);
          data["startTimestamp"] = startTimestamp;
          data["endTimestamp"] = endTimestamp;
          this.socket.emit("rent", data);
        } else {
          this.socket.emit("search", data);
        }

        this.dispatching = true;
        window.events.$emit("dispatched");
      }
    },
    estimate() {
      if (this.vehicleType && this.pickupAddress && this.destinationAddress) {
        console.log("estimate");
        this.socket.emit("estimate", {
          vehicleType: this.vehicleType,
          pickUpAddress: this.pickupAddress,
          dropOffAddress: this.destinationAddress
        });
      }
    },
    validateTicket() {
      this.ticketError = false;
      this.ticketId = "";
      if (this.ticket.length == 10 && this.phoneNumber) {
        this.ticketLoading = true;
        this.$http
          .get(`tickets/validate/${this.ticket}/+251${this.phoneNumber}`)
          .then(response => {
            if (response && response.data) {
              this.ticketId = response.data;
              this.ticketLoading = false;
              this.ticketError = false;
            }
          })
          .catch(err => {
            this.ticketError = true;
            console.log(err);
          })
          .finally(() => {
            this.ticketLoading = false;
          });
      }
    },
    searchDriver(name) {
      if (name) {
        this.$http
          .get("drivers/search?vehicle=true&limit=5&q=" + name)
          .then(drivers => {
            this.drivers = drivers.data.map(driver => {
              if (driver.vehicle != null && driver.vehicle.online == true) {
                driver.disabled = false;
              } else {
                driver.disabled = true;
              }
              return driver;
            });
            console.log(drivers.data);
          })
          .catch(err => console.log(err))
          .finally(() => (this.loading = false));
      } else {
        this.drivers = [];
      }
    },
    searchRiders(phone) {
      this.riderName = "";
      this.riderId = "";
      this.email = "";
      if (phone) {
        this.$http
          .get("users/search?limit=5&q=" + phone)
          .then(riders => {
            this.riders = riders.data;
            var rider = this.riders.find(
              rider => rider.phoneNumber == "+251" + phone
            );
            if (rider) {
              this.selectRider(rider);
            }
            console.log(riders.data);
          })
          .catch(err => console.log(err))
          .finally(() => (this.loading = false));
      } else {
        this.riders = [];
      }
    },
    selectDriver(driver) {
      if (!driver.disabled) {
        this.selectedDriver = driver;
        this.driverName =
          driver.firstName + " " + driver.lastName + " - " + driver.phoneNumber;
        this.drivers = [];
        console.log(this.selectedDriver);
      }
    },
    selectRider(rider) {
      if (rider) {
        this.riderId = rider._id;
        this.riderName = rider.firstName + " " + rider.lastName;
        this.email = rider.email;
        var pn = rider.phoneNumber.replace("+251", "");
        if (pn.length == 9 && pn[0] == "9") {
          this.phoneNumber = pn;
        } else if (pn.length == 10 && pn[0] == "0") {
          this.phoneNumber = pn.replace("0", "");
        }
        this.riders = [];
      }
    }
  }
};
</script>

<style lang="sass">
.pac-item
  @apply py-2 text-gray-700

.pac-item-matched
  @apply font-semibold

.pac-item-query
  @apply font-amharic text-sm text-gray-900
</style>
